import { ResizeSensor } from "css-element-queries"
import React, { useCallback, useEffect, useRef, useState } from "react"

const AutoGrid: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const [childWidth, setChildWidth] = useState(0)
  const gridRef = useRef<HTMLDivElement>(null)
  const sensor = useRef<ResizeSensor | null>(null)

  const updatePadding = useCallback(() => {
    const grid = gridRef.current

    if (!grid || grid.children.length === 0) {
      return
    }

    const childWidth = grid.children.item(0)?.getBoundingClientRect().width || 0
    setChildWidth(childWidth)
  }, [])

  useEffect(() => {
    if (gridRef.current) {
      sensor.current = new ResizeSensor(gridRef.current, updatePadding)
    }

    updatePadding()

    return () => {
      if (sensor.current) {
        sensor.current.detach(updatePadding)
      }
    }
  }, [updatePadding])

  return (
    <div
      className="auto-grid grid flex-1 justify-items-center"
      style={{ gridTemplateColumns: `repeat(auto-fill, minmax(${childWidth}px, 1fr))` }}
      ref={gridRef}
    >
      {React.Children.map(children, child => child && child)}
    </div>
  )
}

export default AutoGrid
